export default (actionTypes, wrapData, historyObj) => {
	return (state = defaultState, action) => {
		let newState
		switch (action.type) {
		case actionTypes.fetch:
			return {
				...action,
				isFetching: true
			}
		case actionTypes.receive:

			if (wrapData) {

				if (historyObj && historyObj.isActive) {
					newState = action.payload.data

					const currency = newState[0][historyObj.id]

					return {
						data: [
							...state.data.filter(d => d[historyObj.id] !== currency),
							...newState
						],
						isFetching: false
					}
				}


				newState = action.payload
				return {
					data: [  ...newState ],
					isFetching: false
				}
			}

			newState = action.payload
			return {
				...newState,
				isFetching: false
			}
		default:
			return state
		}
	}
}

const defaultState = {
	isFetching: null,
	data: []
}
